import {apiTransactionsRequests} from '#/repository/api-transactions-requests';
import {useQuery} from '@tanstack/react-query';

export const useLastProcessedApiBlockNumber = () =>
  useQuery({
    queryKey: ['last-processed-database-block-number'],
    queryFn: apiTransactionsRequests.getTransactionsLastProcessedBlock,
  });
